
const digest = 'f522be84ba35b61158b77075518f5b262453f97699711b1ad39575560dfcc4d9';
const classes = {"container":"_container_1z0f4_1","list":"_list_1z0f4_5","item":"_item_1z0f4_21","selected":"_selected_1z0f4_29"};
const css = `._container_1z0f4_1 {
  height: 100%;
}

._list_1z0f4_5 {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  background-color: #2e333c;
  color: #7a8599;
  font-family: "Roboto", sans-serif;
  height: 100%;
}

._list_1z0f4_5:hover {
  cursor: pointer;
}

._item_1z0f4_21 {
  font-size: 18px;
  line-height: 16px;
  max-height: 32px;
  font-weight: 500;
  padding: 14px;
}

._item_1z0f4_21._selected_1z0f4_29 {
  color: white;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  